import {InputNumber, type InputNumberProps} from "primereact/inputnumber";

/** Von {@link CurrencyInputNumber} fest vorgegebene Props, die Aufrufer nicht überschreiben können. */
type FixedProps = "suffix" | "prefix" | "mode" | "currency" | "minFractionDigits" | "maxFractionDigits" | "useGrouping";

export interface CurrencyInputNumberProps extends Omit<InputNumberProps, FixedProps | "locale"> {
    /** Sprache der Oberfläche; bestimmt Dezimal- und Tausendertrennzeichen. */
    locale: string;
}

/**
 * Projektweites Eingabefeld für Euro-Beträge: zwei Nachkommastellen, Tausendertrennzeichen,
 * Suffix " €" und rechtsbündige Ausrichtung. Alle übrigen Props (value, onValueChange, disabled,
 * invalid, placeholder, aria-label, className …) werden an PrimeReacts {@link InputNumber}
 * durchgereicht; ein übergebenes `inputClassName` wird um `text-right` ergänzt.
 */
export function CurrencyInputNumber({inputClassName, ...rest}: CurrencyInputNumberProps) {
    return (
        <InputNumber
            {...rest}
            inputClassName={inputClassName ? `${inputClassName} text-right` : "text-right"}
            minFractionDigits={2}
            maxFractionDigits={2}
            useGrouping={true}
            suffix=" €"
        />
    );
}
